import React, { useState } from 'react';
import { FiSearch, FiEdit, FiTrash2, FiPower, FiUnlock } from 'react-icons/fi';
import Button from '../common/Button';

function UsersTab({
  users,
  loading,
  searchTerm,
  roleFilter,
  statusFilter,
  onSearchChange,
  onRoleFilterChange,
  onStatusFilterChange,
  onRefresh
}) {
  const [selectedUser, setSelectedUser] = useState(null);

  const handleToggleUserStatus = async (user) => {
    try {
      // API call to toggle user status
      console.log('Toggle status for user:', user._id);
      // await usersAPI.toggleStatus(user._id);
      onRefresh();
    } catch (error) {
      console.error('Error toggling user status:', error);
    }
  };

  const handleDeleteUser = async (user) => {
    if (window.confirm(`Are you sure you want to delete user ${user.fullName}?`)) {
      try {
        // API call to delete user
        console.log('Delete user:', user._id);
        // await usersAPI.delete(user._id);
        onRefresh();
      } catch (error) {
        console.error('Error deleting user:', error);
      }
    }
  };

  return (
    <div>
      {/* Filters */}
      <div className="flex flex-col lg:flex-row gap-4 mb-4">
        <div className="flex-1">
          <div className="relative">
            <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#7a7060]" />
            <input
              type="text"
              placeholder="Search users by name, email, or mobile..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border rounded-lg text-[13px] outline-none transition-shadow focus:shadow-sm focus:border-[#145f5f40]"
              style={{ borderColor: '#e8e2d6' }}
            />
          </div>
        </div>

        <div className="flex gap-3">
          <select
            value={roleFilter}
            onChange={(e) => onRoleFilterChange(e.target.value)}
            className="px-4 py-2 border rounded-lg text-[13px] transition-colors hover:border-[#b8b0a0]"
            style={{ borderColor: '#e8e2d6' }}
          >
            <option value="all">All Roles</option>
            <option value="admin">Admin</option>
            <option value="super_admin">Super Admin</option>
            <option value="professional">Professional</option>
            <option value="corporate">Corporate</option>
          </select>

          <select
            value={statusFilter}
            onChange={(e) => onStatusFilterChange(e.target.value)}
            className="px-4 py-2 border rounded-lg text-[13px] transition-colors hover:border-[#b8b0a0]"
            style={{ borderColor: '#e8e2d6' }}
          >
            <option value="all">All Status</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>

          {/* Refresh is owned by AdminDashboardPage's top header. */}
        </div>
      </div>

      {/* Users Table */}
      {loading ? (
        <div className="text-center py-20 text-[#7a7060]">
          <div className="animate-pulse">Loading users…</div>
        </div>
      ) : (
      <div className="bg-white rounded-[12px] border overflow-hidden" style={{ borderColor: '#ddd6c6', boxShadow: '0 2px 16px rgba(8,17,31,.07)' }}>
        <div className="overflow-x-auto cs-table-scroll">
          <table className="w-full text-[12px]">
            <thead>
              <tr className="text-[10px] uppercase tracking-wider text-[#7a7060] border-b" style={{ borderColor: '#e8e2d6', background: '#f8f5ef' }}>
                <th className="text-left py-3 px-4">User</th>
                <th className="text-left py-3 px-4">Contact</th>
                <th className="text-left py-3 px-4">Role</th>
                <th className="text-left py-3 px-4">Status</th>
                <th className="text-left py-3 px-4">Verified</th>
                <th className="text-left py-3 px-4">Joined</th>
                <th className="text-center py-3 px-4">Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user._id} className="border-b last:border-0 transition-colors hover:bg-[#f8f5ef]" style={{ borderColor: '#f0ebe0' }}>
                  <td className="py-3 px-4">
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 rounded-full bg-[#145f5f] text-white flex items-center justify-center text-[11px] font-semibold">
                        {user.fullName?.charAt(0)?.toUpperCase() || 'U'}
                      </div>
                      <div>
                        <div className="font-medium text-[#08111f]">{user.fullName}</div>
                        {user.profession && (
                          <div className="text-[10px] text-[#7a7060]">{user.profession}</div>
                        )}
                      </div>
                    </div>
                  </td>
                  <td className="py-3 px-4">
                    <div className="text-[#7a7060]">
                      <div>{user.email}</div>
                      <div className="text-[10px]">{user.mobile}</div>
                    </div>
                  </td>
                  <td className="py-3 px-4">
                    <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold ${
                      user.roleName === 'super_admin' ? 'bg-[#f2e9e6] text-[#9a564a]' :
                      user.roleName === 'admin' ? 'bg-[#f3ebd7] text-[#8a6a1f]' :
                      user.roleName === 'professional' ? 'bg-[#e3f0ed] text-[#145f5f]' :
                      user.roleName === 'corporate' ? 'bg-[#edeef3] text-[#3a4a66]' :
                      'bg-[#f2eee6] text-[#8a7d66]'
                    }`}>
                      {user.roleName === 'super_admin' ? 'Super Admin' :
                       user.roleName === 'admin' ? 'Administrator' :
                       user.roleName === 'professional' ? 'Professional' :
                       user.roleName === 'corporate' ? 'Corporate' :
                       user.roleName || 'User'}
                    </span>
                  </td>
                  <td className="py-3 px-4">
                    <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold ${
                      user.isActive !== false ? 'bg-[#e8efe5] text-[#4a6b3f]' : 'bg-[#f2e9e6] text-[#9a564a]'
                    }`}>
                      {user.isActive !== false ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td className="py-3 px-4">
                    <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold flex items-center gap-1 ${
                      user.isPhoneVerified ? 'bg-[#e8efe5] text-[#4a6b3f]' : 'bg-[#f2eee6] text-[#8a7d66]'
                    }`}>
                      {user.isPhoneVerified ? (
                        <>
                          <span>Verified</span>
                        </>
                      ) : (
                        <>
                          <span>Not Verified</span>
                        </>
                      )}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-[#7a7060]">
                    {new Date(user.createdAt).toLocaleDateString()}
                  </td>
                  <td className="py-3 px-4">
                    <div className="flex items-center justify-center gap-2">
                      <Button
                        variant="ghost"
                        size="sm"
                        iconOnly
                        title={user.isActive !== false ? 'Deactivate' : 'Activate'}
                        onClick={() => handleToggleUserStatus(user)}
                      >
                        {user.isActive !== false ? <FiPower className="text-[14px]" /> : <FiUnlock className="text-[14px]" />}
                      </Button>
                      <Button variant="ghost" size="sm" iconOnly title="Edit" onClick={() => setSelectedUser(user)}>
                        <FiEdit className="text-[14px]" />
                      </Button>
                      <Button variant="ghost" size="sm" iconOnly title="Delete" onClick={() => handleDeleteUser(user)}>
                        <FiTrash2 className="text-[14px]" style={{ color: '#9a564a' }} />
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
              {users.length === 0 && (
                <tr>
                  <td colSpan={7} className="py-12 text-center text-[#7a7060]">
                    No users found matching your criteria
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      )}

      {/* Pagination */}
      {!loading && users.length > 0 && (
        <div className="flex items-center justify-between mt-4 text-[12px] text-[#7a7060]">
          <div>Showing {users.length} users</div>
          <div className="flex gap-2">
            <button className="px-3 py-1 border rounded transition-colors hover:bg-[#f8f5ef] hover:border-[#b8b0a0]" style={{ borderColor: '#e8e2d6' }}>Previous</button>
            <button className="px-3 py-1 border rounded transition-colors hover:bg-[#f8f5ef] hover:border-[#b8b0a0]" style={{ borderColor: '#e8e2d6' }}>Next</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default UsersTab;
